import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';
import { PreloaderModule } from './preloader/preloader.module';
@NgModule({
  exports: [
    ComponentsModule,
    PreloaderModule,
  ],
  declarations: []
})
export class ThemeModule { }
